<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" width="100px" persistent>
            <div class="text-center" style="background-color:#fff;width:100px;height:120px;padding-top:20px;">
                <v-progress-circular
                        :size="50"
                        indeterminate
                        style="margin-bottom:10px;"
                        color="primary"
                ></v-progress-circular>
                <p>加载中...</p>
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
  export default {
    name: "ZLoading",
    props:{
      value:{
        type:Boolean,
        required: true,
        default:false
      }
    },
    computed:{
      dialog: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      },
    },
    data: () => ({

    })
  }
</script>

<style scoped>

</style>